import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FilterRecordService } from 'src/app/services/filter-record.service';
import { PatientService } from 'src/app/services/patient.service';
import { AuthService } from '../../../services/auth.service';
import { PhysicianFilter } from '../../../model/physician-Filter';

@Component({
  selector: 'app-patient-crm-filter',
  templateUrl: './patient-crm-filter.component.html',
  styleUrls: ['./patient-crm-filter.component.css']
})
export class PatientCrmFilterComponent implements IFilterComponent { 

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;
 
  constructor(private formBuilder: FormBuilder,
    private patientService: PatientService,
    private authService: AuthService,
    private filterRecordService: FilterRecordService) { 
    this.form = this.formBuilder.group({ 
      Number: [''],
      LastName: [''],
      FirstName: [''],
      Deleted: [false],
    }); 
  } 

  getSearchFilters(): SearchFilter[] {
    return this.filterRecordService.convertToSearchFilters(this.form);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters('AdmissionReceptionFilterComponent', this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters('AdmissionReceptionFilterComponent', this.form);
  }

  async search(): Promise<any> {

    let physicianId = null;
    
    if ( this.authService.filterPhysicianInPatient() &&
         !this.authService.canViewPatientOtherProfesional()) {
      physicianId = this.authService.getPhysicianId();
    }

    return await this.patientService.getPatientCrmSearchItems(
        (this.form.controls.LastName.value ? this.form.controls.LastName.value : '')
      , (this.form.controls.FirstName.value ? this.form.controls.FirstName.value : '')
      , (this.form.controls.Deleted.value ? this.form.controls.Deleted.value : false)
      , (this.form.controls.Number.value ? this.form.controls.Number.value : null)
      , physicianId);
  }
}
